import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=54526228&scoped=true&"
import script from "./EmailEditor.vue?vue&type=script&lang=js&"
export * from "./EmailEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailEditor.vue?vue&type=style&index=0&id=54526228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54526228",
  null
  
)

export default component.exports